<div
  #element
  *ngIf='isVisible && content'
  class='tooltip'
  [style.max-width]='content.richToolTip ? content.richToolTip.maxWidth : null'
  [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'"
>
  <tooltip-viewer
    *ngIf='content.richToolTip; else renderPlain'
    [title]='content.title'
    [description]='content.description'
    [topOffset]='content.richToolTip.topOffset'
    [leftOffset]='content.richToolTip.leftOffset'
  ></tooltip-viewer>

  <ng-template #renderPlain>
    <div class='tooltip-body' *ngIf='content.title && content.description'>
      <p class='tooltip-title' *ngIf='content.title'>
        {{ content.title }}
      </p>

      <p class='tooltip-description' *ngIf='content.description'>
        {{ content.description }}
      </p>
    </div>
  </ng-template>
</div>
